import { Alert, Form, Input, Modal } from 'antd';
import type { DirectoryTagView } from '../directory-tags.api';

interface RenameDirectoryTagModalProps {
  /** The entry being renamed; the modal is open while there is one. */
  tag: DirectoryTagView | null;
  error: string | null;
  saving: boolean;
  onSubmit: (tag: DirectoryTagView, name: string) => Promise<boolean>;
  onClose: () => void;
}

export function RenameDirectoryTagModal({ tag, error, saving, onSubmit, onClose }: RenameDirectoryTagModalProps) {
  const [form] = Form.useForm<{ name: string }>();

  return (
    <Modal
      open={tag !== null}
      title="Rename entry"
      okText="Save"
      onOk={() => form.submit()}
      onCancel={onClose}
      confirmLoading={saving}
      afterOpenChange={(open) => open && form.setFieldsValue({ name: tag?.name })}
      destroyOnHidden
    >
      {error && <Alert className="mb-4" type="error" title={error} showIcon />}
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={async ({ name }) => {
          if (tag && (await onSubmit(tag, name))) onClose();
        }}
      >
        <Form.Item
          name="name"
          label="Name"
          extra="Records keep the same entry; only the name shown changes."
          rules={[{ required: true, whitespace: true, message: 'Enter a name' }]}
        >
          <Input autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
}
